// extracted by mini-css-extract-plugin
module.exports = {"token":"AnimatedText_token__XHO4b","active":"AnimatedText_active__nJvQi"};